<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="question-mark-circle-outline"></nb-icon>
        <div class="ml-2">{{ title }}</div>
      </div>
      <button nbButton class="ml-3" (click)="clickedNo()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div style="white-space: pre-line">{{ message }}</div>
    </div>
    <div class="row">
      <div>
        <br />
        <input nbInput id="deploy" name="deploy" placeholder="CONFIRM" [(ngModel)]="userInput" />
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="danger" (click)="clickedNo()">
        {{ noButton }}
      </button>
      <button nbButton class="ml-3" status="success" (click)="clickedYes()" [disabled]="userInput !== 'CONFIRM'">
        {{ yesButton }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
